import { useMutation } from '@tanstack/react-query'
import { claimFriendsAndFamilyReferral } from 'api/friendsAndFamilyDiscount'
import { useAppSelector } from 'hooks/reduxHooks'
import { showSnackbar } from 'LuxKit/Snackbar/AppSnackbar'
import { useIntl } from 'react-intl'

interface Params {
  fnfEmailPrefix?: string
  onSuccess?: () => void
}

function useClaimFriendsAndFamilyReferral(params: Params) {
  const { fnfEmailPrefix, onSuccess } = params
  const intl = useIntl()
  const referralName = useAppSelector(state => state.auth.account.fullName)

  return useMutation({
    mutationFn: () => {
      if (!fnfEmailPrefix) {
        return Promise.reject(new Error('Missing friends and family email prefix'))
      }

      return claimFriendsAndFamilyReferral({
        fnfEmailPrefix,
        referralName,
      })
    },
    onError: () => {
      showSnackbar(intl.formatMessage({
        id: 'ycttzvMHKDSj_00iKlzM',
        defaultMessage: 'Something went wrong while claiming your access',
        description: 'Snackbar error message shown when claiming friends and family access fails',
      }), 'critical')
    },
    onSuccess: () => {
      showSnackbar(intl.formatMessage({
        id: 't1KECdQ2ThA18TUOlyf5',
        defaultMessage: 'Claim request submitted for approval',
        description: 'Snackbar success message shown when a friends and family access claim request is submitted for approval',
      }), 'success')
      onSuccess?.()
    },
  })
}

export default useClaimFriendsAndFamilyReferral
